import React from "react";
import {
  Accordion,
  DoubleContent,
  List,
  SectionContent,
  TextBodyAccordion,
  LinkPrimary,
} from "../../../../components";
import { links } from "../../../../config";
import TarifasTable from "./DuvidasFrequentes.Style";
import { diferencaSorteioLance } from "../../data";

const tarifa = "1% do valor do crédito atualizado, por pedido";

const leftAccordion = [
  {
    title: "Como funciona o consórcio?",
    body: (
      <TextBodyAccordion>
        O consórcio funciona como uma modalidade de compra coletiva, onde um
        grupo de pessoas se compromete a pagar uma parcela mensal, por um tempo
        determinado. Esse dinheiro é guardado em um fundo comum e, todo mês,
        alguns integrantes do grupo são escolhidos (por sorteio e lance) para
        receber o valor do crédito e comprar o bem.
      </TextBodyAccordion>
    ),
  },
  {
    title: "Quais as vantagens do consórcio?",
    body: (
      <>
        <TextBodyAccordion>
          <strong>Sem juros</strong>
          Com o consórcio você escolhe uma parcela que cabe no seu bolso e não
          paga juros, somente a taxa de administração que é diluída no prazo
          contratado.{" "}
        </TextBodyAccordion>
        <TextBodyAccordion>
          <strong>Opção para pagar o lance</strong>
          Se não tiver o dinheiro no bolso, em alguns grupos você poderá pagar o
          lance usando até 50% do valor do crédito. Somos a única empresa a
          oferecer esse diferencial.
        </TextBodyAccordion>
        <TextBodyAccordion>
          <strong>Abatimento em taxas e impostos</strong>
          Você pode usar até 10% do valor do crédito para pagar despesas
          referentes ao bem, como seguros, tributos e registros.
        </TextBodyAccordion>
      </>
    ),
  },
  {
    title: "O que é cobrado na parcela do meu consórcio?",
    body: (
      <>
        <TextBodyAccordion>
          No consórcio você não paga juros. Veja para que o seu dinheiro será
          destinado:
        </TextBodyAccordion>
        <TextBodyAccordion>
          <strong>Fundo Comum:</strong> é o valor que será reunido para a compra
          do bem. É desse fundo que tiramos o crédito que será destinado aos
          contemplados e, havendo saldo no encerramento do grupo, será devolvido
          aos consorciados ativos e cancelados.
        </TextBodyAccordion>
        <TextBodyAccordion>
          <strong> Fundo de Reserva:</strong> esse fundo é essencial para manter
          a saúde financeira do grupo. O valor é destinado a uma reserva em
          casos de imprevistos como cobrir uma eventual falta de dinheiro no
          Fundo Comum e, havendo saldo no encerramento do grupo, o mesmo será
          devolvido aos consorciados ativos.
        </TextBodyAccordion>
        <TextBodyAccordion>
          <strong>Taxa de Administração:</strong> é o valor que a gente cobra
          para administrar seu consórcio. A Taxa de Administração é diferente
          dos juros cobrados em outras modalidades, por isso é bem menor. Ela é
          dividida durante o tempo contratado: um pedacinho em cada parcela.
        </TextBodyAccordion>
        <TextBodyAccordion>
          <strong>Seguro Prestamista:</strong> esse seguro é opcional e cobrado
          a partir da 2ª parcela. Em caso de morte ou invalidez total e
          permanente do consorciado, o seguro quita o saldo devedor do seu
          consórcio. Trata-se de uma escolha importante para quem quer cuidar da
          família.
        </TextBodyAccordion>
        <TextBodyAccordion>
          <strong>Seguro Danos Físicos ao Imóvel (DFI):</strong> exclusivo para
          o Consórcio Imobiliário, esse seguro é cobrado somente após a
          aquisição, construção, reforma e/ou ampliação do imóvel.
        </TextBodyAccordion>
      </>
    ),
  },
  {
    title: "Posso alterar o valor do meu crédito?",
    body: (
      <TextBodyAccordion>
        Enquanto você não for contemplado é possível mudar os planos e se
        adaptar a uma nova realidade. Você pode, por exemplo, aumentar ou
        reduzir o valor do crédito (dentro do limite do seu grupo) e pagar uma
        nova parcela. Essa alteração pode ser feita apenas 2 vezes.
      </TextBodyAccordion>
    ),
  },
  {
    title: "Como é atualizado o valor do meu crédito?",
    body: (
      <TextBodyAccordion>
        O valor do crédito é corrigido de acordo com o Índice Nacional de Preços
        ao Consumidor - INPC. A cada 12 assembleias do grupo, o crédito é
        atualizado com ajuste da parcela e do saldo devedor. Assim, seu poder de
        compra é mantido.
      </TextBodyAccordion>
    ),
  },
  {
    title: "O que são as assembleias?",
    body: (
      <>
        <TextBodyAccordion>
          Todos os meses é realizada uma reunião chamada Assembleia Geral
          Ordinária - AGO. É nela que acontece o sorteio e a avaliação dos
          lances que definirão os contemplados de cada mês. Fique atento: para
          participar das assembleias, é importante que as suas parcelas sejam
          pagas até o vencimento.
        </TextBodyAccordion>
        <TextBodyAccordion>
          Temos também a Assembleia Geral Extraordinária - AGE, que pode ser
          convocada a qualquer momento, pela empresa ou pelo grupo, quando
          existir a necessidade de definir assuntos de interesse de todos.
        </TextBodyAccordion>
      </>
    ),
  },
  { ...diferencaSorteioLance },
  {
    title: "Onde posso ofertar um lance?",
    body: (
      <>
        <TextBodyAccordion>
          Os lances podem ser ofertados até às 20h do dia anterior à assembleia
          (horário de Brasília), por meio da{" "}
          <LinkPrimary href={links.consorcio.areaLogada} target="_blank">
            Área do cliente
          </LinkPrimary>{" "}
          ou pela Central de Serviços e Relacionamento:
        </TextBodyAccordion>
        <List styleType="disc">
          <li>
            <LinkPrimary href="tel:08002741000"> 0800 274 1000</LinkPrimary>{" "}
            (Das 8h às 21h, de segunda a sexta, exceto em feriados nacionais).
          </li>
        </List>
      </>
    ),
  },
  {
    title: "É possível pagar o lance com o valor do crédito contratado?",
    body: (
      <>
        <TextBodyAccordion>
          Quando você compra o consórcio, pode optar por um grupo que oferece a
          possibilidade de pagar o lance com o valor do crédito contratado. É
          uma ótima opurnidade para você que não possui dinheiro para ofertar um
          lance ou que deseja complementar o valor da oferta com algum dinheiro
          que já tem.
        </TextBodyAccordion>

        <TextBodyAccordion>
          Se você ofertou um lance e foi contemplado, terá um novo valor de
          crédito disponível e poderá optar por reduzir o valor das parcelas ou
          o prazo.
        </TextBodyAccordion>

        <strong>Confira um exemplo de lance com o valor do crédito:</strong>
        <TextBodyAccordion>
          A Dani queria comprar um apê que custava R$ 200 mil. Ela não tinha
          dinheiro guardado para ofertar lance livre ou fixo e também não podia
          esperar muito tempo pra comprar o apê. Por isso, ela planejou a compra
          do crédito de consórcio já pensando em usar 50% do valor para dar um
          lance.
        </TextBodyAccordion>

        <TextBodyAccordion>
          Ao invés de comprar um crédito no valor do apê, ela comprou no valor
          dobrado, ou seja, de R$ 400 mil. Depois de pagar a primeira parcela,
          ela ofertou o lance com 50% do valor do crédito.
        </TextBodyAccordion>

        <TextBodyAccordion>
          Dessa forma, a Dani fez um lance de R$ 200 mil (que representa os 50%)
          mesmo sem ter o dinheiro, porque ela usou o crédito do seu consórcio.
        </TextBodyAccordion>

        <TextBodyAccordion>
          Quando foi contemplada, a Dani recebeu R$ 200 mil. Exatamente o valor
          do apê! :)
        </TextBodyAccordion>

        <TextBodyAccordion>
          E sabe o que é melhor? A Dani comprou seu apê em pouco tempo e sem
          juros. Ela vai pagar pelos R$ 200 mil que usou para comprar o apê,
          mais as taxas sobre o valor total do crédito contratado.
        </TextBodyAccordion>
      </>
    ),
  },
];

const rigthAccordion = [
  {
    title: "Resultado das assembleias",
    body: (
      <TextBodyAccordion>
        Mensalmente acontece a Assembleia Geral Ordinária (AGO) que define os
        consorciados contemplados. Para conferir se hoje é o seu dia de sorte,{" "}
        <LinkPrimary href={links.consorcio.assembleias} label="acesse aqui" />.
      </TextBodyAccordion>
    ),
  },
  {
    title: "O que acontece quando sou contemplado?",
    body: (
      <TextBodyAccordion>
        Quando você for contemplado, você será avisado por e-mail e SMS. Conheça
        aqui o{" "}
        <LinkPrimary href={links.consorcio.contemplacao}>
          passo a passo para solicitar o uso do seu crédito.
        </LinkPrimary>
      </TextBodyAccordion>
    ),
  },
  {
    title: "Como usar o meu FGTS no Consórcio Imobiliário?",
    body: (
      <>
        <TextBodyAccordion>
          Existem algumas opções para usar o Fundo de Garantia do Tempo de
          Serviço (FGTS) no seu Consórcio Imobiliário, de acordo com as regras
          do próprio fundo. São elas:
        </TextBodyAccordion>
        <List styleType="disc">
          <li>
            <TextBodyAccordion elementType="span">
              Complementar o pagamento do valor do imóvel a ser adquirido;
            </TextBodyAccordion>
          </li>
          <li>
            <TextBodyAccordion elementType="span">
              Pagar parte das parcelas do seu consórcio e também amortizar; ou
            </TextBodyAccordion>
          </li>
          <li>
            <TextBodyAccordion>
              Quitar o saldo devedor após a aquisição do imóvel.{" "}
            </TextBodyAccordion>
          </li>
        </List>
        <TextBodyAccordion>
          <LinkPrimary target="_blank" href={links.consorcio.cartilhaFgts}>
            Para saber mais, consulte aqui a cartilha para o uso do FGTS
          </LinkPrimary>
        </TextBodyAccordion>
      </>
    ),
  },
  {
    title: "Como saber mais sobre os seguros do meu consórcio?",
    body: (
      <TextBodyAccordion>
        Temos 2 seguros para cuidar da sua família e do imóvel adquirido.{" "}
        <LinkPrimary href={links.consorcio.seguros}>
          Conheça aqui as opções.
        </LinkPrimary>
      </TextBodyAccordion>
    ),
  },
  {
    title:
      "Existe alguma tarifa para usar o meu crédito ou transferir a minha cota?",
    body: (
      <>
        <TextBodyAccordion>
          Consulte aqui os valores das tarifas previstas no contrato de adesão,
          vigentes a partir de 01/04/2020, por tipo de serviço. Essas tarifas se
          aplicam para ao uso do crédito e transferência de titularidade da
          cota.
        </TextBodyAccordion>
        <TarifasTable>
          <thead>
            <tr>
              <th colSpan="2">
                Tarifas previstas para o Consórcio Imobiliário
              </th>
            </tr>
          </thead>
          <tr>
            <td>
              Laudo de avaliação para aquisição de imóvel ou do projeto de obra
              para construção
            </td>
            <td>R$ 750,00 por imóvel</td>
          </tr>
          <tr>
            <td>
              Laudo de mediação do acompanhamento da execução de obra:
              construção, reforma ou ampliação
            </td>
            <td>R$ 500,00 por medição</td>
          </tr>
          <tr>
            <td>
              ¹Elaboração do Instrumento Particular (¹Para cotas adquiridas até
              08/03/2019)
            </td>
            <td>R$ 350,00 por emissão</td>
          </tr>
          <tr>
            <td>
              ²Análise jurídica da documentação imobiliária e elaboração do
              Instrumento Particular - (²Para cotas adquiridas a partir de
              09/03/2019)
            </td>
            <td>R$ 1.500,00 por processo</td>
          </tr>
          <tr>
            <td>
              Análise do pedido de transferência de cota
              <li>
                Cobrança de 50% no ato do pedido (não reembolsável em caso de
                não aprovação do comprador)
              </li>
              <li>Cobrança de 50% após a aprovação do pedido</li>
            </td>
            <td>{tarifa}</td>
          </tr>
          <tr>
            <td>Transferência de cota cancelada</td>
            <td>R$ 300,00 por pedido</td>
          </tr>
          <tr>
            <td>Substituição da garantia</td>
            <td>{tarifa}</td>
          </tr>
          <tr>
            <td>
              Cobrança extrajudicial, nos casos de inadimplência da cota
              contemplada com o bem entregue
            </td>
            <td>Honorários advocatícios, conforme o caso</td>
          </tr>
          <tr>
            <td>Emissão de 2ª via do Instrumento Particular para alienação</td>
            <td>R$ 250,00 por pedido</td>
          </tr>
          <tr>
            <td>
              Emissão de 2ª via do instrumento de liberação da alienação
              fiduciária
            </td>
            <td>R$ 250,00 por pedido</td>
          </tr>
          <tr>
            <td>Taxa de acompanhamento do processo de construção</td>
            <td>R$ 18,00 por vistoria</td>
          </tr>
        </TarifasTable>
        <TarifasTable>
          <thead>
            <tr>
              <th colSpan="2">
                Tarifas previstas para o Consórcio de Veículos
              </th>
            </tr>
          </thead>
          <tr>
            <td>
              Serviços de faturamento de veículo e despesas com a formalização
              da garantia (não reembolsável em caso de desistência do pedido)
            </td>
            <td>R$ 450,00 por processo</td>
          </tr>
          <tr>
            <td>
              Análise do pedido de transferência de cota ativa
              <li>
                Cobrança de 50% no ato do pedido (não reembolsável em caso de
                não aprovação do comprador)
              </li>
              <li> Cobrança de 50% após a aprovação do pedido</li>
            </td>
            <td>{tarifa}</td>
          </tr>
          <tr>
            <td>Transferência de cota cancelada</td>
            <td>R$ 300,00 por pedido</td>
          </tr>
          <tr>
            <td>Substituição da garantia</td>
            <td>{tarifa}</td>
          </tr>
          <tr>
            <td>Alteração da UF na alienação após a entrega do bem</td>
            <td>Taxa do DETRAN, conforme a região</td>
          </tr>
          <tr>
            <td>
              Cobrança extrajudicial - inadimplência da Cota contemplada com o
              bem entregue
            </td>
            <td>Honorários Advocatícios, conforme o caso</td>
          </tr>
          <tr>
            <td>
              Laudo de avaliação para aquisição de embarcação ou aeronave usada
            </td>
            <td>Taxa da Empresa Especializada em Vistoria, conforme o caso</td>
          </tr>
          <tr>
            <td>Taxa de avaliação do fiador</td>
            <td>R$650,00 por pedido</td>
          </tr>
        </TarifasTable>
      </>
    ),
  },
  {
    title: "Como fazer uma transferência de cota?",
    body: (
      <TextBodyAccordion>
        Você pode transferir a titularidade de sua cota ativa ou cancelada.{" "}
        <LinkPrimary href={links.consorcio.desisti}>
          Saiba mais aqui.
        </LinkPrimary>
      </TextBodyAccordion>
    ),
  },
  {
    title: "Quais serviços posso fazer on-line?",
    body: (
      <>
        <List styleType="disc">
          <li>
            <TextBodyAccordion elementType="span">
              Emitir 2ª via do boleto;
            </TextBodyAccordion>
          </li>
          <li>
            <TextBodyAccordion elementType="span">
              Atualizar seus dados cadastrais;
            </TextBodyAccordion>
          </li>
          <li>
            <TextBodyAccordion elementType="span">
              Consultar o extrato da sua cota;
            </TextBodyAccordion>
          </li>
          <li>
            <TextBodyAccordion elementType="span">
              Ofertar lances;
            </TextBodyAccordion>
          </li>
          <li>
            <TextBodyAccordion elementType="span">
              Visualizar as atas das assembleias;
            </TextBodyAccordion>
          </li>
          <li>
            <TextBodyAccordion elementType="span">
              Alterar o pagamento para débito em conta;
            </TextBodyAccordion>
          </li>
          <li>
            <TextBodyAccordion elementType="span">
              Acessar seu Informe para o Imposto de Renda;
            </TextBodyAccordion>
          </li>
          <li>
            <TextBodyAccordion elementType="span">
              Consultar a Cartilha de Orientações para o consorciado
              contemplado;
            </TextBodyAccordion>
          </li>
          <li>
            <TextBodyAccordion elementType="span">
              Movimentar a sua cota, como transferência de titularidade e
              solicitação do uso do crédito;
            </TextBodyAccordion>
          </li>
          <li>
            <TextBodyAccordion>
              Consultar informações sobre o encerramento do seu grupo.
            </TextBodyAccordion>
          </li>
        </List>
        <TextBodyAccordion>
          Acesse agora sua conta na{" "}
          <LinkPrimary href={links.consorcio.areaLogada} target="_blank">
            Área do Cliente
          </LinkPrimary>{" "}
          ou{" "}
          <LinkPrimary target="_blank" href={links.areaLogadaCadastro}>
            faça seu cadastro
          </LinkPrimary>
          .
        </TextBodyAccordion>
      </>
    ),
  },
  {
    title: "O que acontece quando o meu grupo é encerrado?",
    body: (
      <>
        <TextBodyAccordion>
          Quando o grupo cumpre o prazo do consórcio contratado e realiza a
          última assembleia, ele é encerrado. Veja o que você precisa saber
          quando ocorre o encerramento:
        </TextBodyAccordion>
        <List styleType="disc">
          <li>
            <TextBodyAccordion>
              Você será avisado pelo e-mail cadastrado se houver dinheiro
              sobrando. Neste aviso, informamos que você deve entrar em contato
              com a Central de Serviços e Relacionamento:
            </TextBodyAccordion>
            <List styleType="disc">
              <li>
                <TextBodyAccordion>
                  0800 274 1000 das 8h às 21h, de segunda a sexta, exceto em
                  feriados nacionais.
                </TextBodyAccordion>
              </li>
            </List>
          </li>
          <li>
            <TextBodyAccordion>
              A quantia a ser devolvida será proporcional ao valor do crédito,
              dividido entre todos os consorciados ativos.
            </TextBodyAccordion>
          </li>
          <li>
            <TextBodyAccordion>
              É necessário manter os dados cadastrais e bancários atualizados,
              pois os valores somente serão devolvidos em conta bancária.
            </TextBodyAccordion>
          </li>
          <li>
            <TextBodyAccordion>
              <strong>
                FIQUE ATENTO: A solicitação do seu valor deve ser feita até 30
                dias depois do recebimento do aviso por e-mail. Após essa data,
                será cobrada uma taxa de permanência mensal de 5%, sobre o valor
                total a receber.
              </strong>
            </TextBodyAccordion>
          </li>
        </List>
      </>
    ),
  },
];

const DuvidasFrequentes = () => {
  return (
    <SectionContent>
      <DoubleContent
        leftContent={<Accordion listItems={leftAccordion} />}
        rightContent={<Accordion listItems={rigthAccordion} />}
      />
    </SectionContent>
  );
};

export default DuvidasFrequentes;
